<template>
  <b-modal ref="paymentModal" title="Zahlung verbuchen">
    <div v-if="payment">
      <b-input-group size="md" :append="payment.total.currency" prepend="Summe">
        <b-form-input type="number" v-model="payment.total.price" disabled></b-form-input>
      </b-input-group>
      <b-input-group size="md" :append="payment.payed.currency" prepend="Bezahlt (Alt)">
        <b-form-input type="number" v-model="payment.payed.price" disabled></b-form-input>
      </b-input-group>
      <b-input-group size="md" :append="payment.payed.currency" prepend="Bezahlt (Neu)">
        <b-form-input type="number" v-model="payment.payed.float"></b-form-input>
      </b-input-group>
    </div>

    <template slot="modal-footer">
      <b-btn class="mt-3" variant="danger" block @click="save">Speichern</b-btn>
      <b-btn class="mt-3" variant="secondary" block @click="hide">Abbrechen</b-btn>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: 'PaymentModal',

  data: function () {
    return {
      id: null,
      payment: null
    }
  },

  methods: {
    edit (id) {
      this.id = id
      this.axios.get('/registrations/' + this.id + '/payment')
        .catch(err => this.$eventHub.$emit('error', err))
        .then(rsp => { this.payment = rsp.data })

      this.$refs.paymentModal.show()
    },

    save () {
      const id = this.id
      const payload = {payed: this.payment.payed.float}
      this.axios.put('/registrations/' + this.id + '/payment', payload)
        .catch(err => this.$eventHub.$emit('error', err))
        .then((rsp) => {
          this.$emit('update', id, rsp.data)
        })
        .finally(() => this.$refs.paymentModal.hide())
    },

    hide () {
      this.$refs.paymentModal.hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/admin/registration/PaymentModal.vue